import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=17740e6e&scoped=true"
import script from "./EditArticle.vue?vue&type=script&lang=js"
export * from "./EditArticle.vue?vue&type=script&lang=js"
import style0 from "./EditArticle.vue?vue&type=style&index=0&id=17740e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17740e6e",
  null
  
)

export default component.exports